import React, { Fragment } from 'react'
import BrandongPositionModal from 'components/branding-position'
import Component from 'components/component'
import HelmetWrap from 'components/helmet-wrap'
import { Link } from 'components/link'
import { Modal } from 'components/modal'
import frontload from 'hoc/frontload'
import page from 'hoc/page'
import { DI } from 'modules'
import { TABOOLA_ID } from '../../../init'
import ChoosePlanColumn from './choose-plan-column'
import * as config from 'config'

class ChoosePlan extends Component {
  static preload(props) {
    const slug = 'plans'
    return props.actions.frontpages.getFrontPage(slug)
  }

  state = {
    modalBrandingPosition: false,
    modalPassDescription: false,
  }

  columns = []

  toggleModal = key => ev => {
    ev && ev.preventDefault()
    this.setState({
      [key]: !this.state[key],
    })
  }

  render() {
    const { strings, locale } = this.props.common
    const { currentUser } = this.props.user
    const meta_tag = this.props.frontpages.info.payload.meta_tag

    /* const isShowPrice =
      currentUser.isInited &&
      !currentUser.pending &&
      currentUser.payload.user_group !== 'client' */

    const isShowPrice = true

    return (
      <Fragment>
        <HelmetWrap {...(meta_tag || {})} page="pricing" />

        <section className="content">
          {this.state.modalBrandingPosition && (
            <BrandongPositionModal
              onClose={this.toggleModal('modalBrandingPosition')}
              onSubmit={null}
            />
          )}
          {this.state.modalPassDescription && (
            <Modal onClose={this.toggleModal('modalPassDescription')}>
              <PassDescription strings={strings} />
            </Modal>
          )}
          <div className="wrap">
            <div className="choose-plan">
              <span className="choose-plan__title">
                {strings['page.plans.title']}
              </span>
              <div className={`choose-plan-plans choose-plan-plans--${locale}`}>
                {false && (
                  <ChoosePlanColumn
                    title={strings['page.plans.pass.title']}
                    text={strings['page.plans.pass.subtitle']}
                    info={strings['page.plans.pass.info']}
                    mp4
                    bottom={
                      /* <RPassBottom strings={strings} /> */
                      <div className="choose-plan-plan-buy">
                        <span className="choose-plan-plan__title">
                          {
                            strings[
                              'page.plans.ruptly_pass.payment_method_unavailable_1'
                            ]
                          }
                        </span>
                        <div className="choose-plan-plan-text">
                          {
                            strings[
                              'page.plans.pass.payment_method_unavailable_2'
                            ]
                          }{' '}
                          <a
                            className="text-button"
                            href={
                              'mailto:' +
                              strings[
                                'page.plan_details.agreements.contact_info.email'
                              ]
                            }
                          >
                            {
                              strings[
                                'page.plan_details.agreements.contact_info.email'
                              ]
                            }
                          </a>
                          .
                        </div>
                      </div>
                    }
                    modals={{
                      modalBrandingPosition: this.toggleModal(
                        'modalBrandingPosition'
                      ),
                      modalPassDescription: this.toggleModal(
                        'modalPassDescription'
                      ),
                    }}
                  />
                )}
                {locale === 'ru' && (
                  <ChoosePlanColumn
                    title={strings['page.plans.region.title']}
                    text={strings['page.plans.region.subtitle']}
                    info={strings['page.plans.region.info']}
                    mp4
                    mxf
                    bottom={<RRegionBottom strings={strings} />}
                  />
                )}
                <ChoosePlanColumn
                  title={strings['page.plans.enterprise.title']}
                  text={strings['page.plans.enterprise.subtitle']}
                  info={strings['page.plans.enterprise.info']}
                  mp4
                  mxf
                  bottom={
                    isShowPrice ? <EnterpriseBottom strings={strings} /> : <></>
                  }
                />
              </div>
              <div className="choose-plan-text">
                <p>
                  {strings['page.plans.text.line1']}
                  <Link
                    to="/"
                    className="choose-plan-skip__link"
                    onClick={() => {
                      window._tfa &&
                        window._tfa.push({
                          notify: 'event',
                          name: 'add_to_cart',
                          id: TABOOLA_ID,
                        })
                    }}
                  >
                    {strings['page.plans.text.link']}
                  </Link>
                </p>
                <p>{strings['page.plans.text.line2']}</p>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export const planPrice = {
  monthly: '12.5',
  annually: '96',
}

function RRegionBottom({ strings }) {
  return (
    <Fragment>
      <div className="choose-plan-plan-buy">
        <span className="choose-plan-plan__cost">
          {strings['page.plans.region.cost']}
        </span>
        <span className="choose-plan-plan__paying">
          {strings['page.plans.region.paying']}
        </span>
      </div>
      <div className="choose-plan-button">
        <Link to="/plans/request-region" className="button button--black">
          {strings['page.plans.region.button']}
        </Link>
      </div>
    </Fragment>
  )
}

function EnterpriseBottom({ strings }) {
  return (
    <Fragment>
      <div className="choose-plan-plan-buy">
        <span className="choose-plan-plan__cost">
          {strings['page.plans.enterprise.cost']}
        </span>
        <span className="choose-plan-plan__paying">
          {strings['page.plans.enterprise.paying']}
        </span>
      </div>
      <div className="choose-plan-button">
        <Link to="/plans/request-subscription" className="button button--black">
          {strings['page.plans.enterprise.button']}
        </Link>
      </div>
    </Fragment>
  )
}

function PassDescription(props) {
  return (
    <div className="popup-text">
      <div className="text">
        {Object.entries(props.strings['page.plans.pass_modal']).map(
          ([title, text], index) => (
            <Fragment key={index}>
              <h4>{title}</h4>
              <p>{text}</p>
            </Fragment>
          )
        )}
      </div>
    </div>
  )
}

export default page(DI(['frontpages', 'user'])(frontload(ChoosePlan)))
